import { createFileRoute, notFound } from "@tanstack/react-router";
export const Route = createFileRoute("/branding")({ beforeLoad: () => { throw notFound(); } });